(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["promotion-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('trainbot-promotion')) {
    customElements.define('trainbot-promotion', class extends HTMLElement {
      connectedCallback() {
        this.refresh = this.refresh || (() => {
          clearTimeout(this.expiryTimer);
          const now = Date.now();
          const starts = Number(this.dataset.starts);
          const expires = Number(this.dataset.expires);
          this.hidden = !Number.isFinite(starts) || !Number.isFinite(expires) || now < starts || now >= expires;
          if (!this.hidden) {
            this.expiryTimer = setTimeout(this.refresh, Math.min(expires - now, 86400000));
          }
        });
        document.addEventListener('visibilitychange', this.refresh);
        window.addEventListener('pageshow', this.refresh);
        this.refresh();
      }
      disconnectedCallback() {
        clearTimeout(this.expiryTimer);
        document.removeEventListener('visibilitychange', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
